import { IApplicationState } from '../../types/redux';

export const animationDelayMsSelector = (state: IApplicationState): number => {
  return state.consultantCianChat.animationDelayMs;
};
